import React, { useEffect, useState } from 'react';
import {
  Button,
  Form,
  Header,
  Input,
  Label,
  Modal,
  Segment,
  Table,
} from 'semantic-ui-react';
import { API, showError, showSuccess } from '../../helpers';

const ConsumptionInvoice = () => {
  const [requests, setRequests] = useState([]);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(0);
  const [statusFilter, setStatusFilter] = useState(0);
  const [doneModal, setDoneModal] = useState(null);
  const [remark, setRemark] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const loadRequests = async () => {
    setLoading(true);
    try {
      let url = `/api/consumption_invoice/admin/requests?p=${page}`;
      if (statusFilter > 0) url += `&status=${statusFilter}`;
      const res = await API.get(url);
      const { success, data, message } = res.data;
      if (success) {
        setRequests(data || []);
      } else {
        showError(message);
      }
    } catch (_) {
      showError('加载失败');
    }
    setLoading(false);
  };

  useEffect(() => {
    loadRequests();
  }, [page, statusFilter]);

  const handleMarkDone = async () => {
    if (!doneModal) return;
    setSubmitting(true);
    try {
      const res = await API.put(`/api/consumption_invoice/admin/requests/${doneModal}/done`, {
        remark: remark.trim(),
      });
      const { success, message } = res.data;
      if (success) {
        showSuccess('已标记完成');
        setDoneModal(null);
        setRemark('');
        loadRequests();
      } else {
        showError(message);
      }
    } catch (_) {
      showError('操作失败');
    } finally {
      setSubmitting(false);
    }
  };

  const exportPendingCSV = () => {
    window.open('/api/consumption_invoice/admin/export_pending', '_blank');
  };

  const formatAmount = (fen) => `¥${(fen / 100).toFixed(2)}`;
  const formatQuota = (quota) => quota.toLocaleString();
  const statusLabel = (status) => {
    if (status === 1) return <Label color='yellow' size='small'>待处理</Label>;
    if (status === 2) return <Label color='green' size='small'>已开票</Label>;
    return <Label size='small'>未知</Label>;
  };

  return (
    <Segment>
      <Header as='h3'>消费发票管理</Header>
      <div style={{ marginBottom: '1em', display: 'flex', alignItems: 'center', gap: '1em' }}>
        <Button.Group size='small'>
          <Button active={statusFilter === 0} onClick={() => { setStatusFilter(0); setPage(0); }}>全部</Button>
          <Button active={statusFilter === 1} onClick={() => { setStatusFilter(1); setPage(0); }}>待处理</Button>
          <Button active={statusFilter === 2} onClick={() => { setStatusFilter(2); setPage(0); }}>已开票</Button>
        </Button.Group>
        <Button size='small' color='blue' onClick={exportPendingCSV}>导出待处理</Button>
      </div>
      <div style={{ overflowX: 'auto' }}>
        <Table compact celled unstackable>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell>ID</Table.HeaderCell>
              <Table.HeaderCell>用户</Table.HeaderCell>
              <Table.HeaderCell>邮箱</Table.HeaderCell>
              <Table.HeaderCell>抬头</Table.HeaderCell>
              <Table.HeaderCell>税号</Table.HeaderCell>
              <Table.HeaderCell>月份</Table.HeaderCell>
              <Table.HeaderCell>消费额度</Table.HeaderCell>
              <Table.HeaderCell>兑换抵扣</Table.HeaderCell>
              <Table.HeaderCell>开票金额</Table.HeaderCell>
              <Table.HeaderCell>状态</Table.HeaderCell>
              <Table.HeaderCell>操作</Table.HeaderCell>
            </Table.Row>
          </Table.Header>
          <Table.Body>
            {requests.map((req) => (
              <Table.Row key={req.id}>
                <Table.Cell>{req.id}</Table.Cell>
                <Table.Cell>{req.username}</Table.Cell>
                <Table.Cell>{req.email || '-'}</Table.Cell>
                <Table.Cell>{req.title}</Table.Cell>
                <Table.Cell>{req.tax_number}</Table.Cell>
                <Table.Cell>{req.month}</Table.Cell>
                <Table.Cell>{formatQuota(req.consume_quota)}</Table.Cell>
                <Table.Cell>{formatQuota(req.redemption_quota)}</Table.Cell>
                <Table.Cell>{formatAmount(req.total_amount_fen)}</Table.Cell>
                <Table.Cell>{statusLabel(req.status)}</Table.Cell>
                <Table.Cell>
                  {req.status === 1 && (
                    <Button size='mini' color='green' onClick={() => setDoneModal(req.id)}>
                      标记完成
                    </Button>
                  )}
                  {req.admin_remark && <div style={{ fontSize: '0.85em', color: '#666' }}>{req.admin_remark}</div>}
                </Table.Cell>
              </Table.Row>
            ))}
          </Table.Body>
        </Table>
      </div>
      {!loading && requests.length === 0 && <p>暂无数据</p>}
      <div style={{ marginTop: '1em' }}>
        <Button size='small' disabled={page === 0} onClick={() => setPage(page - 1)}>上一页</Button>
        <Button size='small' disabled={requests.length < 10} onClick={() => setPage(page + 1)}>下一页</Button>
      </div>

      <Modal open={!!doneModal} onClose={() => setDoneModal(null)} size='small'>
        <Modal.Header>标记消费发票申请完成</Modal.Header>
        <Modal.Content>
          <Form>
            <Form.Field>
              <label>备注（可选）</label>
              <Input
                placeholder='如：已发送至邮箱'
                value={remark}
                onChange={(e) => setRemark(e.target.value)}
              />
            </Form.Field>
          </Form>
        </Modal.Content>
        <Modal.Actions>
          <Button onClick={() => setDoneModal(null)}>取消</Button>
          <Button color='green' onClick={handleMarkDone} loading={submitting} disabled={submitting}>
            确认完成
          </Button>
        </Modal.Actions>
      </Modal>
    </Segment>
  );
};

export default ConsumptionInvoice;
